import React from 'react';
import PageNotFound404 from './404/page-not-found-404';

const NoMatch = () => {
  return <PageNotFound404 />;
};

export default NoMatch;
